const main = {
    siteName: 'The West Heaven Hotel',
    home: 'Home',
    about: 'About',
    aboutUs: 'About Us',
    ourServices : 'Our Services',
    rooms: 'Rooms',
    room: 'Room',
    blog: 'Blog',
    faq: 'FAQs',
    contact: 'Contact',
    contactInfo: 'Contact Info',
    infoNews: 'Info News',
    newsPromotions: 'News & Promotions',
    infoCovid: 'Info Covid',
    restaurant: 'Restaurant',
    gallery: 'Gallery',
    posts: 'Posts',
    post: 'Post',
    french: 'Français',
    english: 'English',
    bookNow: 'Book Now',
    watchVideo: 'Watch Video',
    menu: 'Menu',
    usefulLinks: 'Useful Links',
    welcome : 'Welcome to West Heaven',
    welcomeDescription: 'The West Heaven Hotel - The Hotel you need in Douala, Cameroon.',
    scrollDown : 'Scroll down',
    airConditioned : 'Air-conditioned',
    allInclusive : 'All inclusive',
    underProtection : 'Under protection',
    freeWifi : 'Free wifi',
    aboutTitle1 : 'We have 17+ years <1 /> of Experience.',
    aboutDesc1 : "With a staff of qualified and experienced professionals, West Heaven Hotel is here to serve you and offer you a most remarkable stay. From the restaurant to the snack bar, your satisfaction is guaranteed.",
    aboutTitle2 : 'Say yes to comfort and well-being!',
    aboutDesc2 : "Whether you wish to spend a pleasant and exciting time in our snack bar restaurant or just relax and unwind in one of our beautiful rooms, West Heaven Hotel always guarantees your comfort and satisfaction.",
    chooseRoom : 'Choose a room',
    moreAbout : 'More about us',
    waitingForYou : 'West Heaven Hotel is Waiting for You!',
    waitingForYouDesc : 'Sober, comfortable and clean hotel located in Youpwe on the border with bonapriso. The West heaven Hotel offers various types of rooms all very comfortable with a beautiful view of the river. The hotel also has a snack bar restaurant.',
    ourBestRooms : 'Our Best Rooms',
    ourBestRoomsDesc : 'All our rooms are completely soundproofed and air-conditioned and have a beautiful view of the city or the river. The rooms of The West Heaven Hotel are ready to welcome you in the city of Douala in Youpwe, bonapriso.',
    allRooms : 'All Rooms',
    readMore : 'Read more',
    aroundHotel : 'Around The Hotel',
    services : "Services",
    aroundHotelDesc : 'The West Heaven Hotel is located in Youpwe on the border with Bonapriso in the city of Douala. From the hotel you can admire the Wouri river. Here are some services of The West Heaven Hotel.',
    guestFeedback : 'Feedback from our Guests',
    guestFeedbackDesc : "Some of our customers' opinions to give you an idea of who we are.",
    france : 'France',
    ivoryCoast : 'Ivory Coast',
    usa : 'USA',
    belgium : 'Belgium',
    from : 'From',
    newsletter : 'Our Newsletter',
    newsletterDesc : "Discover the latest news, novelties, promotions and events of the West Heaven Hotel in Douala",
    allPublications : 'All Publications',
    allRightReserved : 'All Rights Reserved',
    designWith : 'Design with',
    by : 'by',
    aboutOurHotel : 'About our Hotel',
    firstDescription : 'Located in a privileged area 300m from a branch of the Wouri River, The West Haven Hotel has been named the Youpwe Lighthouse. A coveted location for its fishing and tourist capacity.',
    searchYourRoom : 'Search your Room',
    checkIn : 'Check in',
    checkOut : 'Check out',
    person : 'Person',
    children : 'Children',
    searchRoom : 'Search room',
    reservation : 'Reservation',
    night : 'Night',
    guests : 'Guests',
    reviews : 'Reviews',
    amenity : 'Amenity',
    location :  'Location',
    similarRooms : 'Similar Rooms',
    chooseYourRoom : 'Choose Your Room',
    chooseYourRoomDesc : "The rooms are classified in 3 categories, 🥉Standard rooms, 🥈Comfort rooms, 🥇Senior rooms. It is with elegance and professionalism that our team will be delighted to welcome you 24/7 while guaranteeing you security and discretion.",
    standard : 'Standard',
    comfort : 'Comfort',
    senior : 'Senior',
    allPhotos : 'ALl Photos',
    hotel : 'Hotel',
    landscape : 'Landscape',
    photoGallery : 'Photo Gallery',
    photoGalleryDesc : "Pictures speak louder than words. So take a look at our photo gallery and you'll understand why we make The West Heaven Hotel your favourite destination.",
    getInTouch : 'Get In Touch',
    getInTouchDesc : "We are available 24/7 to answer your questions and concerns. Please feel free to contact us by phone call, WhatsApp message, email or by visiting The West Heaven Hotel directly.",
    welcomes: 'Welcome',
    call : 'Call',
    write : 'Write',
    ourAddress :  'Youpwé Market, Douala, Cameroon',
    leaveA : 'Leave a',
    review : 'review',
    comment : 'comment',
    message : 'message',
    name : 'Name',
    email : 'Email',
    your : 'Your',
    ici : 'here',
    send : 'Send',
    wePromise : 'We promise not to disclose your personal information to third parties.',
    topManager : 'Top Manager',
    receptionist : 'Receptionist',
    headChef : 'Head Chef',
    barman : 'Barman',
    topManagerSpeech : "Everyone would like to be treated like at home in the hotel, and at home - like in a hotel. Hospitality is a quality that is made up of primeval simplicity and antique grandeur.",
    ourTeam : 'Our awesome Team',
    ourTeamDesc :  "The West heaven hotel has a team of qualified and experienced professionals whose sole mission is your comfort and well-being throughout your stay.",
    whatDoWeOffer :  'What We Offer For You',
    whatDoWeOfferDesc: "With a capacity of 10 rooms, West Heaven offers you in addition to the service of Accommodation, Car rental, Tourism, Restoration (Breakfast, grill). Discover the whole of our services",
    carRental : 'Car Rental',
    freeTelephone : 'Free Telephone',
    smartTV : 'Smart TV',
    laundry : 'Laundry',
    snackbar : 'Snack-bar',
    yard : 'Balcony garden',
    yards : 'Balcony gardens',
    shower : 'Shower',
    toiletService :  'Toilet service',
    bidet : 'Bidet',
    soundproofing : 'Soundproofing',
    gardenView : 'view of the garden',
    desk : 'Desk',
    wardrobe : 'Wardrobe',
    balcony : 'Room with balcony',
    breakfast :  'Breakfast',
    riverView : 'View on the river',
    snackView : 'View of the Restaurant - Snack Bar',
    innerRoom : 'Interior of a room',
    roomDecoration : 'room decoration',
    nightView : 'View of the night hotel',
    barView : 'View of the Snack Bar',
    roastChicken: "Roast chicken",
    roastChickenDesc: "Crispy chicken with seasoned mayonnaise. Accompanied by plantain or potato fries",
    grilledChicken: 'Braised fish',
    grilledChickenDesc: 'Sea Bass, Captain, Top, or Mackerel. Served with plantain chips or cassava sticks',
    grilledPork: 'Braised pork',
    grilledPorkDesc: 'Pieces of pork that have been well braised and seasoned to retain a delicate taste. Served with plantain chips',
    suya: 'Suya (Meat skewer)',
    suyaDesc: 'Seasoned beef skewers commonly known as soya. They are eaten with chilli and condiments',
    whisky: 'Great Whiskies',
    whiskyDesc: 'Your branded Great Whiskies are all available in our snack bar at the best local prices',
    localDrinks: 'Local drinks',
    localDrinksDesc: 'All local drinks are available in our snack bar at the best local prices.',
    ourAwesomeMenu : 'Our Awesome Menu',
    ourAwesomeMenuDesc : "Some of delicious dishes you can find at the West Heaven Hotel",
    AllCategories : 'All Categories',
    grills : 'Gilled Food',
    drinks : 'Drinks',
    here : 'here',
    iWantToReserve : 'Hello,+i+want+to+book+this+room:+',
    IWantToReserveARoomFor : 'Hello,+i+want+to+book+a+room+for+',
    persons : '+person',
    and : '+and+',
    childrens : '+children',
    fromThe : '+from+the+',
    toThe : '+to+the+',
    takeAReservation : 'Make a booking',
    phoneOrEmail : 'Email or phone number',
    messageSent  : "Your message has been sent successfully.<1/> We'll contact you very soon",
    success :  'Success',
}

export default main